import { createAction, props } from '@ngrx/store';

import { ClientPoliciesActionTypes } from './types';

/* Client Policies View */
export const init = createAction(ClientPoliciesActionTypes.Init);

export const listViewTypeChanged = createAction(
  ClientPoliciesActionTypes.ListViewTypeChanged,
  props<{ viewType: string }>()
);

export const viewMoreClicked = createAction(
  ClientPoliciesActionTypes.ViewMoreClicked
);

export const filtersChanged = createAction(
  ClientPoliciesActionTypes.FiltersChanged,
  props<{ filters: Record<string, any> }>()
);
